/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessRegistrationInfo { 
    businessType?: BusinessRegistrationInfo.BusinessTypeEnum;
    businessRegistrationNumber?: string;
    businessRegistrationAuthority?: BusinessRegistrationInfo.BusinessRegistrationAuthorityEnum;
    businessRegistrationCountry?: string;
    privacyPolicyUrl?: string;
    termsAndConditionsUrl?: string;
}
export namespace BusinessRegistrationInfo {
    export const BusinessTypeEnum = {
        SoleProprietor: 'SOLE_PROPRIETOR',
        PrivateProfit: 'PRIVATE_PROFIT',
        PublicProfit: 'PUBLIC_PROFIT',
        NonProfit: 'NON_PROFIT',
        Government: 'GOVERNMENT'
    } as const;
    export type BusinessTypeEnum = typeof BusinessTypeEnum[keyof typeof BusinessTypeEnum];
    export const BusinessRegistrationAuthorityEnum = {
        Ein: 'EIN',
        Cbn: 'CBN',
        ProvincialNumber: 'PROVINCIAL_NUMBER',
        Crn: 'CRN',
        Vat: 'VAT',
        Acn: 'ACN',
        Abn: 'ABN',
        Brn: 'BRN',
        Siren: 'SIREN',
        Siret: 'SIRET',
        Nzbn: 'NZBN',
        UstIdNr: 'UST_ID_NR',
        Cif: 'CIF',
        Nif: 'NIF',
        Cnpj: 'CNPJ',
        Uid: 'UID',
        Neq: 'NEQ',
        Other: 'OTHER'
    } as const;
    export type BusinessRegistrationAuthorityEnum = typeof BusinessRegistrationAuthorityEnum[keyof typeof BusinessRegistrationAuthorityEnum];
}


